/**
 * Types and constants for attendance management
 */

// Search modes
export type SearchMode = 'MONTHLY' | 'RANGE';
export type RangeType = 'TODAY' | 'WEEK' | 'MONTH_1' | 'MONTH_6' | 'MONTH_12';
export type FormatType = 'HH:MM:SS' | 'DECIMAL';

// Filters interface
export interface MonthlyAttendanceFilters {
  searchMode: SearchMode;
  year?: number;
  month?: number;
  cutoffId?: number;
  dateFrom?: string;
  dateTo?: string;
  rangeType?: RangeType;
  formatType: FormatType;
}

// Constants for i18n keys
export const RANGE_TYPE_OPTIONS_KEYS = {
  TODAY: 'attendance:monthly.filters.rangeTypes.today',
  WEEK: 'attendance:monthly.filters.rangeTypes.week',
  MONTH_1: 'attendance:monthly.filters.rangeTypes.month1',
  MONTH_6: 'attendance:monthly.filters.rangeTypes.month6',
  MONTH_12: 'attendance:monthly.filters.rangeTypes.month12',
} as const;

export const FORMAT_TYPE_OPTIONS_KEYS = {
  TIME: 'attendance:monthly.filters.formatTypes.time',
  DECIMAL: 'attendance:monthly.filters.formatTypes.decimal',
} as const;

// Helper functions to get translated options
export const getRangeTypeOptions = (translate: (key: string) => string) => [
  { value: 'TODAY', label: translate(RANGE_TYPE_OPTIONS_KEYS.TODAY) },
  { value: 'WEEK', label: translate(RANGE_TYPE_OPTIONS_KEYS.WEEK) },
  { value: 'MONTH_1', label: translate(RANGE_TYPE_OPTIONS_KEYS.MONTH_1) },
  { value: 'MONTH_6', label: translate(RANGE_TYPE_OPTIONS_KEYS.MONTH_6) },
  { value: 'MONTH_12', label: translate(RANGE_TYPE_OPTIONS_KEYS.MONTH_12) },
];

export const getFormatTypeOptions = (translate: (key: string) => string) => [
  { value: 'HH:MM:SS', label: translate(FORMAT_TYPE_OPTIONS_KEYS.TIME) },
  { value: 'DECIMAL', label: translate(FORMAT_TYPE_OPTIONS_KEYS.DECIMAL) },
];
